// Capitaliza a primeira letra de cada palavra — suficiente para o caso de
// uso (nomes de categoria/produto/adicional), sem tentar tratar preposições
// ou siglas.
export function titleCase(value) {
  if (!value) return value;
  return value
    .split(' ')
    .map((word) => (word ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word))
    .join(' ');
}
